import React, {Component, Fragment} from 'react';
import AssetsReport from '../../../../containers/AssetsReport';
import Api from '../../../../services/Api';
import {pick} from 'lodash';
import {Row} from 'reactstrap';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statistics: null,
    };
  }

  async componentDidMount() {
    await this.fetchData();
  }

  fetchData = async () => {
    try {
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/private-statistics',
        null,
        {
          cancelToken: null,
        }
      );
      this.setState({statistics: data});
    } catch (e) {
      console.log('error: ', e);
    }
  };

  render() {
    const {statistics} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={this.props.match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <AssetsReport
          data={statistics ? pick(
            statistics,
            'total_user_balance',
            'bank_balance',
            'reserved_balance',
            'debts',
            'gift',
            'physical_balance',
            'physical_debts'
          ) : null}
        />
      </Fragment>
    );
  }
}

export default List;

// import React, {Fragment, PureComponent} from 'react';
// import {Badge, Row} from 'reactstrap';
// import AssetsReport from '../../../containers/AssetsReport';
// import Breadcrumb from '../../../containers/navs/Breadcrumb';
// import ActivityReport from '../../../containers/ActivityReport';
// import {Colxx, Separator} from '../../../components/common/CustomBootstrap';
// import PrivateStatsChart from '../../../components/PrivateStatsChart';
// import FilterableStatsChart from '../../../components/FilterableStatsChart';
// import {pick, find} from 'lodash';
// import {withTranslation} from 'react-i18next';
// import {store} from '../../../AppRenderer';
// import Api from '../../../services/Api';
//
// class Analytics extends PureComponent {
//   constructor(props) {
//     super(props);
//     this.statistics = {
//       statistics: null,
//       loading: false,
//     };
//     this.filterableBarCharts = [
//       {type: 'user_income', title: props.t('Users Trades')},
//       {type: 'deposit', title: props.t('Deposits')},
//       {type: 'withdraw', title: props.t('Withdraws')},
//     ];
//     this.privateBarCharts = [
//       // {type: 'activeTraderUsersCount', title: props.t('Active Users Count')},
//       {type: 'submittedKycCount', title: props.t('Submitted KYC Count')},
//       {type: 'identityVerifiedUsersCount', title: props.t('Identity Verified Users Count')},
//       {type: 'inExchangeRegisteredUsersCount', title: props.t('In Exchange Registered Users Count')},
//       {type: 'thirdPartyApiRegisteredUsersCount', title: props.t('Third Party Api Registered Users Count')},
//       {type: 'registeredUsersByReferralTokenCount', title: props.t('Registered Users By Referral Token Count')},
//       {type: 'activeLoggedInUsersCount', title: props.t('Active Logged In Users Count')},
//     ];
//     if (props.match.params.group) {
//       this.financialGroup = find(store.getState().app.financialGroups, obj => obj.name === props.match.params.group);
//     }
//   }
//
//   componentDidMount() {
//     this.fetchData();
//   }
//
//   // eslint-disable-next-line react/no-deprecated
//   componentWillReceiveProps(nextProps) {
//     if (nextProps.match.params.group !== this.props.match.params.group) {
//       if (nextProps.match.params.group) {
//         this.financialGroup = find(
//           store.getState().app.financialGroups,
//           obj => obj.name === nextProps.match.params.group
//         );
//         this.fetchData();
//       }
//     }
//   }
//
//   fetchData = async () => {
//     this.setState({
//       loading: true,
//     });
//     try {
//       const {data} = await Api.invoke(
//         'GET',
//         '/admin-ui/private-statistics',
//         null,
//         {
//           cancelToken: null,
//           params: this.financialGroup ? {financialGroupId: this.financialGroup.id} : null,
//         }
//       );
//       this.setState({statistics: data});
//     } catch (e) {
//       console.log('error: ', e);
//     } finally {
//       this.setState({
//         loading: false,
//       });
//     }
//   };
//
//   render() {
//     const {match} = this.props;
//     const {statistics, loading} = this.statistics;
//     if (loading) {
//       return (
//         <Fragment>
//           <div className="loading" />
//         </Fragment>
//       );
//     }
//     return (
//       <Fragment>
//         <Row>
//           <Colxx xxs="12">
//             <Breadcrumb match={match}/>
//             {!!this.financialGroup && <Badge className="text-one font-weight-normal" color="info" pill>{this.financialGroup.name}</Badge>}
//             <Separator className="mb-5"/>
//           </Colxx>
//         </Row>
//         <AssetsReport
//           data={statistics ? pick(
//             statistics,
//             'total_user_balance',
//             'bank_balance',
//             'reserved_balance',
//             'debts',
//             'physical_balance',
//             'physical_debts'
//           ) : null}
//         />
//         <ActivityReport financialGroup={this.financialGroup}/>
//         {this.filterableBarCharts.map((item, index) => (
//           <FilterableStatsChart
//             id={index + 1}
//             key={item.type}
//             type={item.type}
//             title={item.title}
//             financialGroup={this.financialGroup}
//           />
//         ))}
//         {this.privateBarCharts.map((item, index) => (
//           <PrivateStatsChart
//             id={index + 4}
//             key={item.type}
//             title={item.title}
//             data={statistics ? statistics[item.type] : null}
//           />
//         ))}
//       </Fragment>
//     );
//   }
// }
//
// export default withTranslation()(Analytics);
